<mat-icon
  rkTooltip
  [class]="icon"
  [tooltipDescription]="'GLOBAL.MODAL.DISCOVER.TOOLTIP_CONTENT' | translate"
  [tooltipDisabled]="tooltipDisabled()"
  fontSet="fa"
  [fontIcon]="icon"
></mat-icon>
